import * as ActionTypes from './ActionTypes';

export const Dummy = (state = {
    dummy : 'dummy',

}, action) => {
    return state
}